import React, { useEffect } from "react";
import { useForm, FieldValues } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import useRequest from "../../components/hooks/use-request";
import { showToast } from "../../components/toast";
import BackgroundCard from "../../components/background-card";
import CreatePassword from "../../components/auth/create-password/create-password";

const Password = () => {
  const { id } = useParams();
    const { loading, makeRequest } = useRequest(
      `/auth/set-password/${id}`,
      "POST"
    );
    const navigate = useNavigate();
    const { handleSubmit, control, setValue, watch } = useForm<FieldValues>();
  
    useEffect(() => {
      const user = localStorage.getItem("user");
      if (user) {
        const userInfo = JSON.parse(user);
        setValue("password", userInfo.password);
      }
    }, [setValue]);
  
    const createUser = handleSubmit(async (formData) => {
      const user = {
        password: formData.password,
      };
      const [response] = await makeRequest(user);
  
      if (response.status) {
        showToast(response.message, true, {
          position: "top-right",
        });
  
        navigate("/");
      } else {
        showToast(response.message, false, {
          position: "top-right",
        });
      }
    });
  return (
    <>
      <BackgroundCard>
        <CreatePassword createUser={createUser} control={control} loading={loading} watch={watch} />
      </BackgroundCard>
    </>
  );
};

export default Password;
